// src/theme/yofukashi.js
import { createTheme } from "@mui/material/styles";

import system from "./system";
import assets from "./assets";
import components from "./components";
import backgroundStyles from "./backgroundStyles";

export const chiTheme = createTheme({
  system: system,
  assets: assets,
  backgroundStyles: backgroundStyles,
  components: components,
  palette: {
    text: {
      primary: "#FEFEFE",
      secondary: "#BFBFBF",
    },
  },
  typography: {
    fontFamily: {
      body: `"Noto Serif JP", serif`,
    },
    heading: {
      fontFamily: `"Noto Serif JP", serif`,
      color: "white",
      fontSize: 32,
      fontWeight: "bold",
    },
    body: {
      fontFamily: `"Noto Serif JP", serif`,
      color: "white",
    },
    color: {
      primary: "#FEFEFE",
      secondary: "#FEFEFE",
    },
    header: {
      fontFamily: "Noto Serif JP, serif",
      fontSize: "36px",
    },
    story: {
      fontFamily: `Kiwi Maru, serif`,
      fontSize: "18px",
      lineHeight: "1.8",
    },
    ticket: {
      name: {
        fontFamily: `Kaisei Decol, serif`,
        fontSize: "22px",
      },
      description: {
        fontFamily: `Kiwi Maru, serif`,
        fontSize: "14px",
      },
      price: {
        fontFamily: `Kaisei Decol, serif`,
        fontSize: "22px",
      },
      notice: {
        fontFamily: `Kiwi Maru, serif`,
        fontSize: "13px",
      },
    },
  },
  backgroundStyles: {
    EmailSettings: {
      backgroundImage: "url(/chi/background.png)", // publicフォルダの画像を使用
      backgroundSize: "100% auto",
    },
    News: {
      backgroundImage: "url(/chi/background.png)", // publicフォルダの画像を使用
      backgroundSize: "100% auto",
    },
  },
  StyledButton: {
    fontSize: "18px",
    fontFamily: '"Noto Serif JP", serif',
    border: `2px solid white`,
    color: "white",
  },
  Footer: {
    color: "white",
    fontFamily: '"Noto Serif JP", serif',
  },
  Dialog: {
    width: "80%",
    backgroundColor: "#FEFEFE",
    title: {
      fontSize: "16px",
      color: "#333333",
    },
    description: {
      fontSize: "14px",
      color: "#333333",
    },
    button: {
      color: "#333333",
      border: "2px solid #333333",
    },
  },
  Loading: {
    color: "white",
  },
});
